import { createLogger } from "logging";

export const logger = createLogger("RichText");
